/* SILISOUL — collection card quick-add.
   "+" reveals a size picker over the image; tapping a size adds to cart
   via AJAX and shows the theme's native cart notification. */
(function () {
  if (window.__silisoulQuickAddInit) return;
  window.__silisoulQuickAddInit = true;

  var ADD_SECTIONS = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function closeAll(except) {
    document.querySelectorAll('.ss-card.is-picking').forEach(function (c) {
      if (c !== except) c.classList.remove('is-picking');
    });
  }

  function addToCart(button) {
    var id = button.getAttribute('data-ss-variant');
    var card = button.closest('.ss-card');
    if (!id || button.disabled) return;

    button.classList.add('is-loading');

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    body.append('sections', ADD_SECTIONS.join(','));
    body.append('sections_url', window.location.pathname);

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || 'Add failed'); }
        if (card) card.classList.remove('is-picking');

        var notification = document.querySelector('cart-notification');
        if (notification && data.sections) {
          notification.renderContents(data);
        } else {
          // Fallback: go to cart if the notification isn't present.
          window.location.href = root() + 'cart';
        }
      })
      .catch(function (err) {
        console.error('[silisoul] quick add failed', err);
        window.location.href = card ? card.querySelector('.ss-card__media').getAttribute('href') : root();
      })
      .finally(function () {
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-ss-add-toggle]');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('.ss-card');
      var willOpen = !card.classList.contains('is-picking');
      closeAll(card);
      card.classList.toggle('is-picking', willOpen);
      var sizes = card.querySelector('.ss-card__sizes');
      if (sizes) sizes.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
      return;
    }

    var size = e.target.closest('.ss-card__size');
    if (size) {
      e.preventDefault();
      addToCart(size);
      return;
    }

    // Click anywhere else closes open pickers.
    if (!e.target.closest('.ss-card__sizes')) closeAll(null);
  });

  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') closeAll(null);
  });
})();
